/** @jsxImportSource @emotion/react */
import 'twin.macro';

/* eslint-disable @typescript-eslint/no-unused-vars */
import { css } from '@emotion/react';
import { debounce } from 'lodash';
import { DateRangeInput } from '@datepicker-react/styled';
import { CustomDateParams } from 'utils/models';
import {
  customDateRangInputStyle,
  resetReactRangeCss,
} from 'components/shared/twin.styles';

interface DateRangePickerProps {
  dateRange: CustomDateParams;
  onDatesChange: (dateRange: CustomDateParams) => void;
}

export const DateRangePicker = ({
  dateRange,
  onDatesChange,
}: DateRangePickerProps) => {
  return (
    <div tw="relative z-[20]">
      <div css={[customDateRangInputStyle]}>
        <label>
          <span tw="text-15">Date Range</span>
        </label>
        <div tw="flex items-center space-x-10 relative z-[1]">
          <span css={[resetReactRangeCss]}>
            <DateRangeInput
              placement="bottom"
              onDatesChange={debounce((dateRange) => {
                onDatesChange(dateRange);
              }, 0)}
              onFocusChange={(focusedInput) => {
                onDatesChange({
                  ...dateRange,
                  focusedInput: focusedInput as any,
                });
              }}
              startDate={dateRange.startDate} // Date or null
              endDate={dateRange.endDate} // Date or null
              focusedInput={dateRange.focusedInput} // START_DATE, END_DATE or null
              maxBookingDate={new Date()}
              displayFormat="dd/MM/yyyy"
            />
          </span>
        </div>
      </div>
    </div>
  );
};